import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram, Linkedin, Twitter } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img src="/images/cp-logo.png" alt="Dreampack" className="h-12 w-12" />
              <h3 className="text-xl font-bold bg-gradient-to-r from-amber-400 to-yellow-300 bg-clip-text text-transparent">
                DREAMPACK
              </h3>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Premium Basmati Rice Exporters. A strong belief, a bold dream.
            </p>
            <div className="flex space-x-3 mt-4">
              <a href="https://www.facebook.com/amyrahbasmatirice" target="_blank" rel="noopener noreferrer" className="p-2 bg-white/10 rounded-full hover:bg-amber-600 transition-colors" aria-label="Facebook">
                <Facebook size={18} />
              </a>
              <a href="https://www.instagram.com/amyrahbasmatirice/" target="_blank" rel="noopener noreferrer" className="p-2 bg-white/10 rounded-full hover:bg-amber-600 transition-colors" aria-label="Instagram">
                <Instagram size={18} />
              </a>
              <a href="#" className="p-2 bg-white/10 rounded-full hover:bg-amber-600 transition-colors" aria-label="LinkedIn">
                <Linkedin size={18} />
              </a>
              <a href="#" className="p-2 bg-white/10 rounded-full hover:bg-amber-600 transition-colors" aria-label="Twitter">
                <Twitter size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-amber-400">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-400 hover:text-amber-400 transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-amber-400 transition-colors">About Us</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-amber-400 transition-colors">Services</Link></li>
              <li><Link to="/products" className="text-gray-400 hover:text-amber-400 transition-colors">Products</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-amber-400 transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-amber-400">Our Products</h4>
            <ul className="space-y-2 text-gray-400">
              <li>Amyrah Everyday</li>
              <li>Amyrah Excel</li>
              <li>Amyrah Supreme</li>
              <li>Private Labeling</li>
              <li>Custom Packaging</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-amber-400">Contact Us</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-2">
                <MapPin size={16} className="text-amber-400 mt-1 flex-shrink-0" />
                <span className="text-gray-400">1208, 12th Floor, Emaar The Palm Square, Golf Course Ext Road, Gurgaon 122001</span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone size={16} className="text-amber-400 flex-shrink-0" />
                <a href="tel:+919810137856" className="text-gray-400 hover:text-amber-400 transition-colors">+91 9810137856</a>
              </li>
              <li className="flex items-center space-x-2">
                <Mail size={16} className="text-amber-400 flex-shrink-0" />
                <a href="mailto:info@dreampack.in" className="text-gray-400 hover:text-amber-400 transition-colors">info@dreampack.in</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            &copy; {new Date().getFullYear()} Dreampack Solutions Private Limited. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;